/** Return today's date in IST (Asia/Kolkata) as ISO YYYY-MM-DD. */
export function todayIST() {
  // en-CA locale gives ISO-8601 YYYY-MM-DD
  return new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
}

/** Increment-only counter used to guard stale async responses in list pages. */
export function makeReqTracker() {
  let latest = 0;
  return {
    next() { latest += 1; return latest; },
    isLatest(id) { return id === latest; },
  };
}
